import React from 'react';
import ChargebacksExpandedRowComponent from './chargebacks-expanded-row.component';

const ChargebacksExpandedRow = (props) => {
    return <ChargebacksExpandedRowComponent {...props} />;
};

export default ChargebacksExpandedRow;
